const isProduction = process.env.REACT_APP_ENV === 'production';
const mixpanel = isProduction ? window.mixpanel : null;
const profitwell = isProduction ? window.profitwell : null;
const dataLayer = (isProduction && window.dataLayer) || [];

export const identify = (id) => {
    if (mixpanel) {
        mixpanel.identify(id);
    }
};

export const trackUser = (user) => {
    const id = user.get('id');
    const Company = user.getIn(['company', 'name']);
    const Email = user.get('email');
    const Name = user.get('fullName');
    const Plan = user.getIn(['company', 'activeSubscription', 'plan', 'name']);

    if (mixpanel) {
        mixpanel.people.set({
            Company,
            Email,
            Name,
            Plan,
        });
    }

    if (profitwell) {
        profitwell('user_email', Email);
    }

    if (id) {
        identify(id);
    }
};

export const trackEvent = (name, properties) => {
    if (mixpanel) {
        mixpanel.track(name, properties);
    }

    if (dataLayer) {
        dataLayer.push({ event: name, ...properties });
    }
};

export const getTestKeywordUrl = (keywordPhrase, asin) => {
    if (keywordPhrase) {
        const keywordString = `?field-keywords=${encodeURIComponent(keywordPhrase).replace(/%20/g, '+')}`;
        const asinString = asin ? `&field-asin=${asin}` : '';
        const fields = [
            keywordString,
            asinString,
        ].join('');
        const url = `https://www.amazon.com/s${fields}`;

        return url.split(' ').join('+');
    }

    return '';
};
